import { hqEnemyName, lib } from "./common";

/**
 * The M21 enemies (docs/ENEMIES_V2.md) until their own art lands (`art/hq/enemy_<id>.glb` + `_lod1`, icons
 * `hq/icons/enemy_<id>.png`, from the enemy-art pass): each wears an existing unit's model and icon, re-tinted by its
 * own role (enemyLook.ts), so it reads as its own type. The moment the build ships the enemy's own model, it is used
 * instead — model, LOD and icon — with no change here.
 */
export const ENEMY_STAND_IN: Readonly<Record<string, string>> = {
  summoner: "healer", imp: "runner", burrower: "grunt", spellward: "shieldbearer", stunner: "brute",
  // M36 rares: ART's own `enemy_rare_cN` models ship, so no stand-in rows
};

/**
 * A rare's draw scale on top of its model (presentation only: the sim's size, speed and reach are untouched). Rares
 * review 2026-10-27: they were the smallest showpieces on the board (the Salamander, as strong as a boss, 0.70 tall
 * beside a 2.65 t3 tower). Now each stands 1.1-1.4 tall (its set piece above that): the long, low Salamander x2, the
 * Tortoise and the Toad x1.3, the Golem and the Ram x1.15, the Stag x1.1. The rings, motes, foot locks and the drawn
 * stride all follow the scale (enemyBuild.ts); the walks are keyed for these sizes (art/unitkit/anim_rare.py WALK).
 */
export const RARE_OWN_SCALE: Readonly<Record<string, number>> = {
  rare_c1: 1.1, rare_c2: 1.3, rare_c3: 2.0, rare_c4: 1.15, rare_c5: 1.15, rare_c6: 1.3,
};
export function rareScale(id: string): number { return RARE_OWN_SCALE[id] ?? 1; }

/** Whether `id` has art of its own in this build (true for every id without a stand-in). */
export function hasOwnArt(id: string): boolean {
  if (!(id in ENEMY_STAND_IN)) return true;
  const L = lib();
  return !!L && L.ships(hqEnemyName(id));
}

/** The enemy id whose art `id` wears: itself once its own model ships, else its stand-in. */
export function enemyArtId(id: string): string { return hasOwnArt(id) ? id : ENEMY_STAND_IN[id]; }
